import { api } from './api.js';
import { state, setProject } from './state.js';

// Что нужно подтянуть после того, как пользователь опознан. Вынесено из App,
// потому что вход бывает двумя путями: при загрузке страницы (кука уже есть) и
// через форму. Раньше форма state.user выставляла, а справочники не грузила —
// и селекты направления с грейдом оказывались пустыми.

let loading = null;

export async function loadUserData({ force = false } = {}) {
  if (loading && !force) return loading;
  loading = (async () => {
    const [dict, kinds, voices, stt, runner] = await Promise.all([
      api.get('/api/projects/meta/dictionaries').catch(() => null),
      api.get('/api/interview/kinds').catch(() => null),
      api.get('/api/media/tts/voices').catch(() => null),
      api.get('/api/media/stt/status').catch(() => null),
      // Состояние раннера читается и здесь, а не только при загрузке страницы:
      // до входа сервер о нём ничего сказать не может (не знает, чей он), и
      // после входа через форму полоса «агент не запущен» висела бы ложно до
      // ближайшего опроса — полминуты на пустом месте.
      api.get('/api/runner/state').catch(() => null),
    ]);
    if (dict) state.dictionaries = dict;
    if (kinds) state.kinds = kinds.rows;
    if (voices) state.tts = voices;
    if (stt) state.sttReady = Boolean(stt.ready);
    if (runner) state.runner = runner;

    const projects = await api.get('/api/projects').catch(() => null);
    if (projects) {
      state.projects = projects.rows;
      if (!projects.rows.some((p) => p.id === state.projectId)) {
        setProject(projects.rows[0]?.id || null);
      }
    }
  })().finally(() => { loading = null; });
  return loading;
}

/** Справочники нужны почти каждой странице — подстраховка на случай перезахода. */
export async function ensureDictionaries() {
  if (state.dictionaries.tracks?.length && state.kinds.length) return;
  await loadUserData({ force: true });
}
